module.exports = new __parcel__URL__("generic-background.a8b8cb5d.svg").toString();